// Color por ítem del drawer "Análisis de Categorías" (Rentabilidad): barras
// de las cards y líneas de la evolución. Un ítem tiene UN color en todo el
// drawer y lo CONSERVA aunque cambie el rango, la granularidad o el ranking
// (Steve, 2026-10-07): los tokens se reparten en orden alfabético sobre los
// ítems configurados de la categoría (`itemsByCategory` del store, la lista
// completa), no por el orden de aparición en las cards, que cambiaba con cada
// pedido y pintaba a la misma tienda de otro color al mover el rango.
//
// Los ítems que no están configurados pero vienen en el payload («Sin
// <categoría>», o un valor viejo del clasificador) van después, también en
// orden alfabético, así los configurados mantienen su color aunque aparezca o
// desaparezca «Sin tienda». Con más de 12 ítems la rueda vuelve a empezar y
// dos ítems pueden compartir color (hasta 2026-10-07 el reparto por aparición
// evitaba repetir en las cards, al costo de cambiar de color entre rangos).
// Puro, sin Vue.

export const ITEM_COLOR_TOKENS = [
	"--progress-bar-1",
	"--progress-bar-2",
	"--progress-bar-3",
	"--progress-bar-4",
	"--progress-bar-5",
	"--progress-bar-6",
	"--progress-bar-7",
	"--progress-bar-8",
	"--progress-bar-9",
	"--progress-bar-10",
	"--progress-bar-11",
	"--progress-bar-12",
];

const collator = new Intl.Collator("es", { sensitivity: "base", numeric: true });

function sortedUnique(names) {
	return [...new Set(names.filter((name) => name != null))].sort(collator.compare);
}

/**
 * Token de color (`--progress-bar-N`) por nombre de ítem, estable entre
 * pedidos: alfabético sobre los ítems configurados y después los demás.
 * @param {string[]} configuredItems ítems de la categoría en el store.
 * @param {string[]} payloadItems ítems del payload (pueden traer «Sin …»).
 * @returns {Object<string, string>}
 */
export function itemColorTokens(configuredItems = [], payloadItems = []) {
	const configured = sortedUnique(configuredItems);
	const known = new Set(configured);
	const extra = sortedUnique(payloadItems.filter((name) => !known.has(name)));
	return [...configured, ...extra].reduce((acc, name, i) => {
		acc[name] = ITEM_COLOR_TOKENS[i % ITEM_COLOR_TOKENS.length];
		return acc;
	}, {});
}
